module.exports = __webpack_public_path__ + "static/media/Moj-7.ca5104e1.PNG";